import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { RestartJourneyEffects } from '@common/data-access-shared';
import {
  AppProvidersConfig,
  AppProvidersConfigToken,
  CommonBaseFeatureCoreModule,
  CommonFeatureCoreModule,
} from '@common/feature-core';
import { CommonUiSalesComponentsModule } from '@common/ui-sales-components';
import { ENVIRONMENT, REQUEST_SOURCE } from '@common/util-foundation';
import { Environment } from '@common/util-models';
import { DgxCommonModule } from '@domgen/dgx-fe-common';
import { DgxComponentsProgressModule } from '@domgen/dgx-fe-components/progress';
import { DgxGAModule } from '@domgen/dgx-fe-ga';
import {
  FooterModule,
  SharedSkyComponentsModule,
  SkyErrorComponent,
} from '@domgen/dgx-ui-whitelabel-components';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import {
  BasketFacade,
  SkyDataAccessBasketModule,
} from '@sky/data-access-basket';
import {
  CatalogFacade,
  SkyDataAccessCatalogModule,
} from '@sky/data-access-catalog';
import { SkyDataAccessImeiModule } from '@sky/data-access-imei';
import { SkyUiComponentsModule } from '@sky/ui-components';
import { environment } from '@sky/util-environment';
import { getRequestSource } from '@sky/util-foundation';

import { SkyAppComponent } from './components/sky-app/sky-app.component';
import { META_REDUCERS } from './meta-reducers/meta-reducers';
import { SkyFeatureShellRoutingModule } from './sky-feature-shell-router.module';

const modules = [SkyFeatureShellRoutingModule];

@NgModule({
  declarations: [SkyAppComponent, SkyErrorComponent],
  imports: [
    ...modules,
    CommonModule,
    CommonUiSalesComponentsModule,
    DgxCommonModule,
    DgxGAModule.forRoot(),
    StoreModule.forRoot(
      {},
      {
        metaReducers: META_REDUCERS,
        runtimeChecks: {
          strictActionImmutability: true,
          strictStateImmutability: true,
        },
      }
    ),
    !environment.production ? StoreDevtoolsModule.instrument() : [],
    SkyDataAccessCatalogModule,
    SkyDataAccessBasketModule,
    CommonBaseFeatureCoreModule,
    SkyUiComponentsModule,
    SharedSkyComponentsModule,
    SkyDataAccessImeiModule,
    FooterModule,
    EffectsModule.forRoot([RestartJourneyEffects]),
    CommonFeatureCoreModule,
    DgxComponentsProgressModule,
  ],
  providers: [
    CatalogFacade,
    BasketFacade,
    {
      provide: ENVIRONMENT,
      useValue: environment,
    },
    {
      provide: REQUEST_SOURCE,
      useFactory: (environment: Environment) => {
        return getRequestSource({
          defaultRequestSource: environment.defaultRequestSource,
          domainBasedRequestSources: environment.domainBasedRequestSources,
        });
      },
      deps: [ENVIRONMENT],
    },
  ],
  exports: [...modules, SkyAppComponent],
})
export class SkyFeatureShellModule {
  static forRoot(
    navigationConfig: AppProvidersConfig
  ): ModuleWithProviders<SkyFeatureShellModule> {
    return {
      ngModule: SkyFeatureShellModule,
      providers: [
        { provide: AppProvidersConfigToken, useValue: navigationConfig },
      ],
    };
  }
}
